export const ENDPOINT = 'https://api.doohyoulike.com/planning';
// export const ENDPOINT = 'http://localhost:4444/planning';
export const CLOUD_ENDPOINT = 'https://storage.googleapis.com/doohyoulike-files'

export const IS_TVOS = window.location.hash.length > 0 || navigator.userAgent.indexOf('SamsungBrowser') !== -1 ? true : false;

export let TOKEN = '';
export const setToken = (token: string) => {
    TOKEN = token;
}

export const SIGN_COLORS: { [key: string]: string } = {
    INTERMARCHE: '#FAEAEA',
    FRANPRIX: '#D94610',
    'CARREFOUR EXPRESS': '#C0D92E',
    'CARREFOUR CONTACT': '#047835',
    'CARREFOUR CITY': '#C0D92E',
    'G 20': '#61C793',
    G20: '#61C793',
    'U EXPRESS': '#DAECEE',
    MONOP: '#E3201A',
    A2PAS: '#C3D03E',
    'MY AUCHAN': '#F24B52',
    'INTERMARCHE EXPRESS': '#FAEAEA',
    'CARREFOUR MARKET': '#EF222A',
    DIAGONAL: '#4AAAE8',
    'O MARCHE FRAIS': '#81BD00',
    'COCCINELLE EXPRESS': '#E31C17',
    UTILE: '#DAECEE'
};
